var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('psi-page-title',{attrs:{"title":_vm.page.title,"icon":_vm.page.icon,"breadcrumbs":_vm.breadcrumbs}}),_c('application-uploads-toolbar'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }